import React from 'react';

import { ManageCurrenciesWizard } from '@swf/first';

import FirstRoute from './FirstRoute';

const ManageCurrenciesRoute: React.FC = () => (
  <FirstRoute component={ManageCurrenciesWizard} noCache />
);

export default ManageCurrenciesRoute;
